<lum-df-form
  lumFileEvents
  [form]="form"
  [data]="data"
  [options]="formOptions$ | async"
  (onFileSuccess)="onFileUploaded($event)"
  (onFileRemove)="onFileRemoved($event)"
>
</lum-df-form>
